import { fetchV1 } from 'helpers/fetch.js';
import { toQueryString } from 'helpers/api.js';

const baseUrl = '/subscriptions';
const pruneUrl = 'subscri';

export default {
  getList(filter) {
    return fetchV1.get(`${baseUrl}?${toQueryString(filter)}`);
  },
  create(entity_id) {
    const req = fetchV1.post(baseUrl, { subscription: { entity_id } });
    fetchV1.pruneKey(pruneUrl);
    // adding the " at the end makes sure we're only targetting the value that ends with this string
    fetchV1.pruneKey(`/brands/${entity_id}"`);
    fetchV1.pruneKey(`/publishers/${entity_id}"`);
    return req;
  },
  remove(entity_id) {
    const req = fetchV1.delete(`${baseUrl}/${entity_id}`);
    fetchV1.pruneKey(pruneUrl);
    // adding the " at the end makes sure we're only targetting the value that ends with this string
    fetchV1.pruneKey(`/brands/${entity_id}"`);
    fetchV1.pruneKey(`/publishers/${entity_id}"`);
    return req;
  },
};
